import React, { useState, useEffect, useRef } from 'react';
import {
  View,
  Text,
  ScrollView,
  Image,
  TextInput,
  TouchableOpacity,
  ActivityIndicator,
  Platform,
  ImageBackground,
  Alert,
  Dimensions,
} from 'react-native';
import { Picker } from '@react-native-picker/picker';
import DateTimePicker from '@react-native-community/datetimepicker';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import { useDispatch, useSelector } from 'react-redux';
import { setBirds, syncBirds, addBird, editBird, removeBird } from '../store/modules/birds';
import { getAuth } from 'firebase/auth';
import { bird_list_table } from '../plugins/table';
import { fileUploadPromise } from '../plugins/firebase-utils';
import { setLeftBtnPressed } from '../store/modules/headers';
import Sortable from 'sortablejs';
import { ja } from 'date-fns/locale';
import { useNavigation } from '@react-navigation/native';
import { MdPhotoCamera, MdCollections } from 'react-icons/md';
import { updateDoc, doc, getFirestore, collection, getDocs, query, where } from 'firebase/firestore';
import heic2any from 'heic2any';
import { parse, format } from 'date-fns';

const screenWidth = Dimensions.get('window').width;
const isMobileScreen = screenWidth < 768; // モバイル端末の判定

const BirdScreen = () => {
  const [windowDimensions, setWindowDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const { width, height } = Dimensions.get('window');
    setWindowDimensions({ width, height });

    const onChange = ({ window }) => {
      setWindowDimensions({ width: window.width, height: window.height });
    };
    Dimensions.addEventListener('change', onChange);

    return () => {
      Dimensions.removeEventListener('change', onChange);
    };
  }, []);

  const db = getFirestore();
  const birdsRef = collection(db, 'birds');
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const listRef = useRef(null);
  const [bid, setBid] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [isNew, setIsNew] = useState(false);
  const [progress, setProgress] = useState(0);
  const [index, setIndex] = useState(0);
  const [name, setName] = useState('');
  const [photo, setPhoto] = useState(require('../assets/images/noimage_photo.png'));
  const [birthday, setBirthday] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [category, setCategory] = useState('インコ');
  const [type, setType] = useState('');
  const [welcome, setWelcome] = useState('');
  const [strong, setStrong] = useState('');
  const [weak, setWeak] = useState('');
  const [favorite, setFavorite] = useState('');
  const [dislikedFood, setDislikedFood] = useState('');
  const [favoriteToy, setFavoriteToy] = useState('');
  const [birdPersonality, setBirdPersonality] = useState('');
  const [medicalHistory, setMedicalHistory] = useState('');
  const [comment, setComment] = useState('');
  const [isBirthdayPickerVisible, setIsBirthdayPickerVisible] = useState(false);
  const [isWelcomePickerVisible, setIsWelcomePickerVisible] = useState(false);
  const reduxBirds = useSelector((state) => state.birds.birds || []);
  const leftBtnPressed = useSelector((state) => state.headers.leftBtnPressed);

  const [inputFocused, setInputFocused] = useState(false);
  const [ageFocused, setAgeFocused] = useState(false);
  const [genderSelected, setGenderSelected] = useState(false);

  useEffect(() => {
    const title = isNew ? '新規登録' : isEdit ? 'プロフィール編集' : '';
    navigation.setOptions({ headerTitle: title });
  }, [isNew, isEdit, navigation]);

  useEffect(() => {
    if (reduxBirds.length === 0) {
      setIsNew(true);
      setIsEdit(true);
      initBirdState();
    }
  }, [reduxBirds]);

  useEffect(() => {
    if (leftBtnPressed) {
      showAdd();
      dispatch(setLeftBtnPressed(false));
    }
  }, [leftBtnPressed, dispatch]);

  const showAdd = () => {
    setIsNew(true);
    setIsEdit(true);
    initBirdState();
  };

  const showEdit = () => {
    setIsEdit(true);
  };

  const initBirdState = () => {
    setBid('');
    setName('');
    setPhoto(require('../assets/images/noimage_photo.png'));
    setBirthday('誕生日');
    setAge('');
    setGender('');
    setCategory('インコ');
    setType('セキセイインコ');
    setWelcome('迎え日');
    setStrong('');
    setWeak('');
    setFavorite('');
    setDislikedFood('');
    setFavoriteToy('');
    setBirdPersonality('');
    setMedicalHistory('');
    setComment('');
    setIsEdit(true);
  };

  const saveForm = async () => {
    const auth = getAuth();
    const user = auth.currentUser;

    setIsLoading(true);

    try {
      let uploadedPhotoUrl = photo;

      if (
        photo &&
        typeof photo === 'string' &&
        (isNew || photo.startsWith('file://') || Platform.OS === 'web') &&
        !photo.includes('firebasestorage.googleapis.com')
      ) {
        const response = await fetch(photo);
        const blob = await response.blob();

        uploadedPhotoUrl = await fileUploadPromise(
          blob,
          `birds/${bid || Date.now()}.jpg`,
          setProgress
        );
      }

      const birdData = {
        bid: bid || Date.now().toString(),
        name,
        photo: uploadedPhotoUrl,
        birthday,
        age,
        gender,
        category,
        type,
        welcome,
        strong,
        weak,
        favorite,
        dislikedFood,
        favoriteToy,
        birdPersonality,
        medicalHistory,
        comment,
        uid: user.uid,
      };

      if (isNew) {
        await dispatch(addBird({ user, bird: birdData }));
      } else {
        await dispatch(editBird({ bird: birdData }));
      }

      await dispatch(syncBirds({ user }));
    } catch (error) {
      console.error('エラー:', error);
      alert('保存に失敗しました');
    }

    setIsLoading(false);
    setIsNew(false);
  };

  // カメラを使って写真を撮影（HEIC対応）
  const takePhoto = async () => {
    try {
      let existingInput = document.getElementById('cameraInput');
      if (existingInput) {
        existingInput.remove();
      }

      const input = document.createElement('input');
      input.id = 'cameraInput';
      input.type = 'file';
      input.accept = 'image/*';
      input.capture = 'environment';
      input.style.display = 'none';

      input.onchange = async (event) => {
        console.log('onchange 発火');

        const file = event.target.files[0];

        if (file) {
          console.log('選択したファイル:', file);

          let fileType = file.type || '';
          const isHEIC =
            fileType.includes('heic') ||
            fileType.includes('heif') ||
            file.name.toLowerCase().endsWith('.heic') ||
            file.name.toLowerCase().endsWith('.heif');

          let imageUri;

          if (isHEIC) {
            console.log('HEIC/HEIF 画像を検出 - 変換開始');

            try {
              const convertedBlob = await heic2any({
                blob: file,
                toType: 'image/jpeg',
                quality: 0.8,
              });

              console.log('変換された JPEG Blob:', convertedBlob);

              const blobForUrl = Array.isArray(convertedBlob)
                ? convertedBlob[0]
                : convertedBlob;

              imageUri = URL.createObjectURL(blobForUrl);
            } catch (error) {
              console.error('HEIC変換エラー:', error);
              alert('HEIC 画像の変換に失敗しました。');
              return;
            }
          } else {
            imageUri = URL.createObjectURL(file);
          }

          console.log('最終的な画像URL:', imageUri);
          setPhoto(imageUri);
        } else {
          console.warn('ファイルが選択されませんでした');
        }

        input.remove();
      };

      document.body.appendChild(input);
      input.click();
    } catch (error) {
      console.error('カメラ起動エラー:', error);
    }
  };

  // 画像ライブラリから画像を選択（HEIC対応）
  const selectImage = async () => {
    try {
      let existingInput = document.getElementById('imageInput');
      if (existingInput) {
        existingInput.remove();
      }

      const input = document.createElement('input');
      input.id = 'imageInput';
      input.type = 'file';
      input.accept = 'image/*';
      input.style.display = 'none';

      input.onchange = async (event) => {
        console.log('onchange 発火');

        const file = event.target.files[0];

        if (file) {
          console.log('選択したファイル:', file);

          let fileType = file.type || '';
          const isHEIC =
            fileType.includes('heic') ||
            fileType.includes('heif') ||
            file.name.toLowerCase().endsWith('.heic') ||
            file.name.toLowerCase().endsWith('.heif');

          let imageUri;

          if (isHEIC) {
            console.log('HEIC/HEIF 画像を検出 - 変換開始');

            try {
              const convertedBlob = await heic2any({
                blob: file,
                toType: 'image/jpeg',
                quality: 0.8,
              });

              console.log('変換された JPEG Blob:', convertedBlob);

              const blobForUrl = Array.isArray(convertedBlob)
                ? convertedBlob[0]
                : convertedBlob;

              imageUri = URL.createObjectURL(blobForUrl);
            } catch (error) {
              console.error('HEIC変換エラー:', error);
              alert('HEIC 画像の変換に失敗しました。');
              return;
            }
          } else {
            imageUri = URL.createObjectURL(file);
          }

          console.log('最終的な画像URL:', imageUri);
          setPhoto(imageUri);
        } else {
          console.warn('ファイルが選択されませんでした');
        }

        input.value = '';
        input.remove();
      };

      document.body.appendChild(input);
      setTimeout(() => input.click(), 0);
    } catch (error) {
      console.error('画像選択エラー:', error);
    }
  };

  const hideForm = () => {
    if (isNew) {
      setIsNew(false);
      initBirdState();
    }
  };

  const birds = useSelector((state) => {
    const unsortedBirds = state.birds.birds || [];
    return [...unsortedBirds].sort((a, b) => {
      if (a.order === undefined && b.order === undefined) return 0;
      if (a.order === undefined) return 1;
      if (b.order === undefined) return -1;
      return a.order - b.order;
    });
  });

  const deleteBird = async () => {
    const confirmed =
      Platform.OS === 'web'
        ? window.confirm('愛鳥の登録を削除しますか。')
        : await showCustomDialog('愛鳥の登録を削除しますか。');

    if (!confirmed) return;

    setIsLoading(true);

    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) {
        alert('ログインしていません');
        return;
      }

      const currentBird = birds.find((bird) => bird.bid === bid);
      if (!currentBird) {
        alert('削除対象の愛鳥が見つかりません');
        return;
      }

      await dispatch(removeBird({ bird: currentBird }));

      const updatedQuerySnapshot = await getDocs(
        query(collection(db, 'birds'), where('uid', '==', user.uid))
      );
      const updatedBirds = updatedQuerySnapshot.docs.map((docSnap) => ({
        ...docSnap.data(),
        bid: docSnap.id,
      }));
      updatedBirds.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      dispatch(setBirds(updatedBirds));

      alert('削除が完了しました');
    } catch (error) {
      console.error('削除エラー:', error);
      alert('削除に失敗しました');
    } finally {
      setIsLoading(false);
    }
  };

  const showCustomDialog = async (message) => {
    return new Promise((resolve) => {
      Alert.alert(
        '確認',
        message,
        [
          { text: 'キャンセル', onPress: () => resolve(false), style: 'cancel' },
          { text: 'OK', onPress: () => resolve(true) },
        ],
        { cancelable: true }
      );
    });
  };

  const filteredBirds = bird_list_table.filter((bird) => bird.type === category);
  const sortableRef = useRef(null);

  const updateForm = (bird) => {
    setBid(bird.bid || '');
    setName(bird.name || '');
    setPhoto(bird.photo || require('../assets/images/noimage_photo.png'));
    setBirthday(bird.birthday || '誕生日');
    setAge(bird.age || '');
    setGender(bird.gender || 'オス');
    setCategory(bird.category || 'インコ');
    setType(bird.type || 'セキセイインコ');
    setWelcome(bird.welcome || '迎え日');
    setStrong(bird.strong || '');
    setWeak(bird.weak || '');
    setFavorite(bird.favorite || '');
    setDislikedFood(bird.dislikedFood || '');
    setFavoriteToy(bird.favoriteToy || '');
    setBirdPersonality(bird.birdPersonality || '');
    setMedicalHistory(bird.medicalHistory || '');
    setComment(bird.comment || '');
  };

  useEffect(() => {
    if (listRef.current) {
      if (sortableRef.current) {
        sortableRef.current.destroy();
      }

      sortableRef.current = new Sortable(listRef.current, {
        animation: 150,
        handle: '[data-drag-handle="true"]', // アイコンだけをドラッグハンドルに
        onEnd: async (evt) => {
          const reorderedBirds = [...birds];
          const [movedItem] = reorderedBirds.splice(evt.oldIndex, 1);
          reorderedBirds.splice(evt.newIndex, 0, movedItem);

          const updatedBirds = reorderedBirds.map((bird, index) => ({
            ...bird,
            order: index,
          }));

          try {
            const db = getFirestore();
            await Promise.all(
              updatedBirds.map((bird) =>
                updateDoc(doc(db, 'birds', bird.bid), { order: bird.order })
              )
            );
          } catch (error) {
            console.error('Error updating order in Firestore:', error);
          }

          dispatch(setBirds(updatedBirds));

          if (updatedBirds.length > 0) {
            const first = updatedBirds[0];
            setBid(first.bid);
            updateForm(first);
          }
        },
      });
    }

    return () => {
      if (sortableRef.current) {
        sortableRef.current.destroy();
        sortableRef.current = null;
      }
    };
  }, [birds, dispatch]);

  useEffect(() => {
    if (reduxBirds.length > 0) {
      const firstBird = reduxBirds.find((bird) => bird.order === 0) || reduxBirds[0];
      setBid(firstBird.bid || '');
      setName(firstBird.name || '');
      setPhoto(firstBird.photo || require('../assets/images/noimage_photo.png'));
      setBirthday(firstBird.birthday || '誕生日');
      setAge(firstBird.age || '');
      setGender(firstBird.gender || '');
      setCategory(firstBird.category || '');
      setType(firstBird.type || '');
      setWelcome(firstBird.welcome || '迎え日');
      setStrong(firstBird.strong || '');
      setWeak(firstBird.weak || '');
      setFavorite(firstBird.favorite || '');
      setDislikedFood(firstBird.dislikedFood || '');
      setFavoriteToy(firstBird.favoriteToy || '');
      setBirdPersonality(firstBird.birdPersonality || '');
      setMedicalHistory(firstBird.medicalHistory || '');
      setComment(firstBird.comment || '');
    }
  }, [reduxBirds]);

  const handleEditBird = (bird) => {
    setIsNew(false);
    setIsEdit(true);
    updateForm(bird);
  };

  useEffect(() => {
    if (!birthday || !birthday.match(/^\d{4}年\d{2}月\d{2}日$/)) {
      setAge('');
      return;
    }

    const today = new Date();
    const birthDate = parse(birthday, 'yyyy年MM月dd日', new Date());
    let calculatedAge = today.getFullYear() - birthDate.getFullYear();

    const hasBirthdayPassed =
      today.getMonth() > birthDate.getMonth() ||
      (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

    if (!hasBirthdayPassed) {
      calculatedAge -= 1;
    }

    setAge(calculatedAge.toString());
  }, [birthday]);

  if (isLoading) {
    return (
      <View style={styles.loadingView}>
        <Text style={styles.loadingText}>送信中... ({Math.floor(progress)} % 完了)</Text>
        <ActivityIndicator size="large" color="#cd2829" />
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <KeyboardAwareScrollView
        extraScrollHeight={28}
        contentContainerStyle={{ flexGrow: 1 }}
        nestedScrollEnabled={true}
        showsVerticalScrollIndicator={false}
      >
        {!isNew && (
          <View style={styles.listContainerBack}>
            <View ref={listRef} style={styles.listContainer}>
              {birds.map((bird, idx) => (
                <View style={styles.listbirdbox} key={bird.bid || idx}>
                  {/* アイコン部分だけをドラッグハンドルにする */}
                  <TouchableOpacity
                    style={styles.birdlistHandle}
                    dataSet={{ dragHandle: 'true' }}
                    activeOpacity={1}
                  >
                    <Image
                      source={require('../assets/images/birdlist.png')}
                      style={styles.birdlistIcon}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  </TouchableOpacity>
                  <View
                    style={[
                      styles.listItem,
                      bird.bid === bid && styles.listItemEditing,
                    ]}
                  >
                    <View style={styles.listbirdblock}>
                      <Image
                        source={{ uri: bird.photo }}
                        style={styles.image}
                        resizeMode="cover"
                      />
                      <Text style={styles.text}>
                        {bird.name.length > 16
                          ? bird.name.slice(0, 16) + '...'
                          : bird.name}
                      </Text>
                    </View>
                    <TouchableOpacity
                      style={styles.editButton}
                      onPress={() => handleEditBird(bird)}
                      activeOpacity={0.8}
                    >
                      <Image
                        source={require('../assets/images/bridedit_icon.png')}
                        style={styles.brideditIcon}
                      />
                      <Text style={styles.editButtonText}>編集</Text>
                    </TouchableOpacity>
                  </View>
                </View>
              ))}
            </View>
            <TouchableOpacity style={styles.addBirdButton} onPress={showAdd}>
              <View style={styles.addBirdButtonText}>
                <Image
                  source={require('../assets/images/plus_icon.png')}
                  style={styles.plusIcon}
                />
                <Text style={[styles.addText]}>追加する</Text>
              </View>
            </TouchableOpacity>
          </View>
        )}
        <View style={styles.Container20}>
          <View style={styles.Container}>
            <ImageBackground
              source={require('../assets/images/swiper_back.png')}
              style={styles.photo_space_back}
            >
              <View style={styles.photo_space}>
                <View>
                  <View style={[styles.editTitleblock]}>
                    <Image
                      source={require('../assets/images/edit_icon.png')}
                      style={styles.editingIcon}
                    />
                    <Text style={[styles.title]}>編集中</Text>
                  </View>
                  <View style={styles.photo_space_middle}>
                    <View style={styles.photo_space_circle}>
                      <Image
                        source={{ uri: photo }}
                        style={styles.photo_space_image}
                      />
                      <TouchableOpacity
                        style={styles.btn_add_image}
                        onPress={selectImage}
                      >
                        <MdCollections size={20} color="#FFF" />
                      </TouchableOpacity>
                      <TouchableOpacity
                        style={styles.btn_add_photo}
                        onPress={takePhoto}
                      >
                        <MdPhotoCamera size={20} color="#FFF" />
                      </TouchableOpacity>
                    </View>
                  </View>
                  <TextInput
                    style={[
                      styles.name_edit,
                      { color: inputFocused || name ? '#555555' : '#bfbfbf' },
                    ]}
                    placeholder="名前"
                    placeholderTextColor="#bfbfbf"
                    autoComplete="off"
                    value={name}
                    onFocus={() => setInputFocused(true)}
                    onBlur={() => setInputFocused(false)}
                    onChangeText={(input) => setName(input)}
                  />
                </View>
              </View>
            </ImageBackground>
            <View style={styles.mainContainer}>
              <Text style={styles.mainContainerTitle}>プロフィール</Text>
              {/* 生年月日 */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>生年月日</Text>
                {Platform.OS === 'web' ? (
                  <>
                    <DatePicker
                      selected={
                        birthday && birthday.match(/^\d{4}年\d{2}月\d{2}日$/)
                          ? parse(birthday, 'yyyy年MM月dd日', new Date())
                          : null
                      }
                      onChange={(date) => {
                        if (date) {
                          setBirthday(
                            format(date, 'yyyy年MM月dd日', { locale: ja })
                          );
                        } else {
                          setBirthday('');
                        }
                      }}
                      dateFormat="yyyy/MM/dd"
                      placeholderText="誕生日を選択"
                      autoComplete="off"
                      className="custom-datepicker"
                      popperClassName="custom-popper"
                      popperPlacement="bottom-start"
                      portalId="datepicker-portal"
                      locale={ja}
                      showYearDropdown
                      dropdownMode="select"
                    />
                    <style>{`
                      .custom-datepicker::placeholder {
                        font-size: 20px;
                      }
                      .custom-datepicker {
                        font-size: 20px;
                        border: none;
                        outline: none;
                        background-color: transparent;
                        padding: 5px;
                      }
                      .react-datepicker__triangle {
                        display: none !important;
                      }
                    `}</style>
                  </>
                ) : (
                  <>
                    <TouchableOpacity
                      onPress={() => setIsBirthdayPickerVisible(true)}
                    >
                      <Text
                        style={
                          birthday ? { color: 'black' } : { color: '#ccc' }
                        }
                      >
                        {birthday
                          ? new Date(birthday).toLocaleDateString()
                          : '誕生日を選択'}
                      </Text>
                    </TouchableOpacity>
                    {isBirthdayPickerVisible && (
                      <DateTimePicker
                        value={birthday ? new Date(birthday) : new Date()}
                        mode="date"
                        display="default"
                        onChange={(event, selectedDate) => {
                          setIsBirthdayPickerVisible(false);
                          if (selectedDate) {
                            setBirthday(selectedDate.toISOString());
                          }
                        }}
                      />
                    )}
                  </>
                )}
              </View>

              <View style={styles.row}>
                {/* 年齢 */}
                <View style={styles.list_item2}>
                  <Text style={styles.list_item_header}>年齢</Text>
                  <View style={styles.list_item_row}>
                    <TextInput
                      style={[
                        styles.list_item_edit_picker,
                        { color: ageFocused || age ? '#555555' : '#bfbfbf' },
                      ]}
                      placeholder="0才"
                      placeholderTextColor="#bfbfbf"
                      value={age}
                      onFocus={() => setAgeFocused(true)}
                      onBlur={() => setAgeFocused(false)}
                      onChangeText={(input) => setAge(input)}
                      editable={false}
                      pointerEvents="none"
                    />
                  </View>
                </View>

                {/* 性別 */}
                <View style={styles.list_item2}>
                  <Text style={styles.list_item_header}>性別</Text>
                  <Picker
                    selectedValue={gender}
                    autoComplete="off"
                    name="bird-gender"
                    style={[
                      styles.list_item_edit_picker,
                      { color: genderSelected || gender ? '#555555' : '#bfbfbf' },
                    ]}
                    onValueChange={(itemValue) => {
                      setGender(itemValue);
                      setGenderSelected(itemValue !== '');
                    }}
                  >
                    <Picker.Item
                      label="不明"
                      value=""
                      style={{ color: '#bfbfbf' }}
                    />
                    <Picker.Item label="男の子" value="オス" />
                    <Picker.Item label="女の子" value="メス" />
                  </Picker>
                </View>
              </View>

              {/* 鳥種カテゴリー */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>鳥種カテゴリー</Text>
                <Picker
                  selectedValue={category}
                  autoComplete="off"
                  name="bird-category"
                  style={[
                    styles.list_item_edit_picker,
                    category ? styles.inputActive : styles.inputPlaceholder,
                  ]}
                  enabled={isEdit}
                  onValueChange={(itemValue) => setCategory(itemValue)}
                >
                  <Picker.Item label="選択してください" value="" />
                  <Picker.Item label="インコ" value="インコ" />
                  <Picker.Item label="オウム" value="オウム" />
                  <Picker.Item label="ローリーロリキート" value="ローリーロリキート" />
                  <Picker.Item label="フィンチ" value="フィンチ" />
                  <Picker.Item label="他" value="他" />
                </Picker>
              </View>

              {/* 鳥種 */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>鳥種</Text>
                <Picker
                  selectedValue={type}
                  autoComplete="off"
                  name="bird-type"
                  style={[
                    styles.list_item_edit_picker,
                    type ? styles.inputActive : styles.inputPlaceholder,
                  ]}
                  enabled={isEdit}
                  onValueChange={(itemValue) => setType(itemValue)}
                >
                  {filteredBirds.map((bird, index) => (
                    <Picker.Item
                      key={index}
                      label={bird.item}
                      value={bird.item}
                    />
                  ))}
                </Picker>
              </View>

              {/* お迎え日 */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>お迎え日</Text>
                {Platform.OS === 'web' ? (
                  <>
                    <DatePicker
                      selected={
                        welcome && welcome.match(/^\d{4}年\d{2}月\d{2}日$/)
                          ? parse(welcome, 'yyyy年MM月dd日', new Date())
                          : null
                      }
                      onChange={(date) => {
                        if (date) {
                          setWelcome(
                            format(date, 'yyyy年MM月dd日', { locale: ja })
                          );
                        } else {
                          setWelcome('');
                        }
                      }}
                      dateFormat="yyyy/MM/dd"
                      placeholderText="お迎え日を選択"
                      autoComplete="off"
                      className="custom-datepicker"
                      popperClassName="custom-popper"
                      popperPlacement="bottom-start"
                      portalId="datepicker-portal"
                      locale={ja}
                      showYearDropdown
                      dropdownMode="select"
                    />
                    <style>{`
                      .custom-datepicker::placeholder {
                        font-size: 20px;
                      }
                      .custom-datepicker {
                        font-size: 20px;
                        border: none;
                        outline: none;
                        background-color: transparent;
                        padding: 5px;
                      }
                      .react-datepicker__triangle {
                        display: none !important;
                      }
                    `}</style>
                  </>
                ) : (
                  <>
                    <TouchableOpacity
                      onPress={() => setIsWelcomePickerVisible(true)}
                    >
                      <Text
                        style={welcome ? { color: 'black' } : { color: '#ccc' }}
                      >
                        {welcome
                          ? new Date(welcome).toLocaleDateString()
                          : 'お迎え日を選択'}
                      </Text>
                    </TouchableOpacity>
                    {isWelcomePickerVisible && (
                      <DateTimePicker
                        value={welcome ? new Date(welcome) : new Date()}
                        mode="date"
                        display="default"
                        onChange={(event, selectedDate) => {
                          setIsWelcomePickerVisible(false);
                          if (selectedDate) {
                            setWelcome(selectedDate.toISOString());
                          }
                        }}
                      />
                    )}
                  </>
                )}
              </View>

              {/* 得意なこと */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>得意なこと</Text>
                <TextInput
                  style={[
                    styles.list_item_data,
                    strong ? styles.inputActive : styles.inputPlaceholder,
                  ]}
                  placeholder="入力してください"
                  value={strong}
                  onChangeText={(input) => setStrong(input)}
                  editable={isEdit}
                />
              </View>

              {/* 好きなごはん */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>好きなごはん</Text>
                <TextInput
                  style={[
                    styles.list_item_data,
                    favorite ? styles.inputActive : styles.inputPlaceholder,
                  ]}
                  placeholder="入力してください"
                  value={favorite}
                  onChangeText={(input) => setFavorite(input)}
                  editable={isEdit}
                />
              </View>

              {/* 好きなおもちゃ */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>好きなおもちゃ</Text>
                <TextInput
                  style={[
                    styles.list_item_data,
                    favoriteToy ? styles.inputActive : styles.inputPlaceholder,
                  ]}
                  placeholder="入力してください"
                  value={favoriteToy}
                  onChangeText={(input) => setFavoriteToy(input)}
                  editable={isEdit}
                />
              </View>

              {/* 愛鳥の性格 */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>愛鳥の性格</Text>
                <TextInput
                  style={[
                    styles.list_item_data,
                    birdPersonality
                      ? styles.inputActive
                      : styles.inputPlaceholder,
                  ]}
                  placeholder="入力してください"
                  value={birdPersonality}
                  onChangeText={(input) => setBirdPersonality(input)}
                  editable={isEdit}
                />
              </View>

              {/* 病気や治療の記録 */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>病気や治療の記録</Text>
                <TextInput
                  style={[
                    styles.list_item_data,
                    { height: 200 },
                    medicalHistory
                      ? styles.inputActive
                      : styles.inputPlaceholder,
                  ]}
                  placeholder="入力してください"
                  value={medicalHistory}
                  onChangeText={(input) => setMedicalHistory(input)}
                  editable={isEdit}
                  multiline
                />
              </View>

              {/* コメント */}
              <View style={styles.list_item}>
                <Text style={styles.list_item_header}>コメント</Text>
                <TextInput
                  style={[
                    styles.list_item_data,
                    { height: 200 },
                    comment ? styles.inputActive : styles.inputPlaceholder,
                  ]}
                  placeholder="入力してください"
                  value={comment}
                  onChangeText={(input) => setComment(input)}
                  editable={isEdit}
                  multiline
                />
              </View>

              <View style={styles.control}>
                <TouchableOpacity style={styles.control_btn_save} onPress={saveForm}>
                  <Text style={styles.control_btn_save_text}>
                    {isNew ? '登録' : '保存'}
                  </Text>
                </TouchableOpacity>

                {isNew && (
                  <TouchableOpacity
                    style={styles.control_btn_cancel}
                    onPress={hideForm}
                  >
                    <Text style={styles.control_btn_cancel_text}>キャンセル</Text>
                  </TouchableOpacity>
                )}

                {!isNew && isEdit && (
                  <TouchableOpacity
                    style={styles.control_btn_cancel}
                    onPress={deleteBird}
                  >
                    <Text style={styles.control_btn_cancel_text}>削 除</Text>
                  </TouchableOpacity>
                )}
              </View>
            </View>
          </View>
        </View>
      </KeyboardAwareScrollView>
    </View>
  );
};

const styles = {
  container: {
    flex: 1,
    padding: 0,
    position: 'relative',
  },
  photo_space: {
    width: '100%',
    height: isMobileScreen ? 425 : 500,
    padding: 30,
  },
  no_bird: {
    flex: 1,
    justifyContent: 'center',
    alignSelf: 'center',
  },
  no_bird_message: {
    alignSelf: 'center',
    fontSize: 16,
    color: '#cd2829',
  },
  editTitleblock: {
    flexDirection: 'row',
    marginBottom: 13,
    marginRight: 'auto',
    textAlign: 'center',
    alignSelf: 'center',
    backgroundColor: '#f3d2d2',
    paddingHorizontal: 15,
    borderRadius: 15,
    alignItems: 'center',
  },
  editingIcon: {
    width: 15,
    height: 15,
    resizeMode: 'contain',
    marginRight: 5,
  },
  title: {
    fontSize: 21,
    color: '#555555',
  },
  photo_space_middle: {
    justifyContent: 'center',
    alignSelf: 'center',
    flexDirection: 'row',
  },
  photo_space_circle: {
    backgroundColor: '#fff',
    borderRadius: '50%',
    width: 270,
    height: 270,
    marginBottom: 10,
  },
  photo_space_image: {
    borderRadius: '50%',
    width: 270,
    height: 270,
  },
  btn_add_photo: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    padding: 10,
    backgroundColor: '#cd2829',
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  btn_add_image: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    padding: 10,
    backgroundColor: '#5ac759',
    borderRadius: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  list_item: {
    paddingTop: 20,
    paddingBottom: 15,
    width: '100%',
    borderBottomColor: '#ddd',
    borderBottomWidth: 1,
  },
  list_item2: {
    paddingTop: 20,
    paddingBottom: 15,
    width: '49%',
    height: '100%',
    borderBottomColor: '#ddd',
    borderBottomWidth: 1,
  },
  list_item_header: {
    color: '#8d8d8d',
    fontSize: isMobileScreen ? 18 : 20,
    width: '100%',
    paddingTop: 3,
    marginBottom: 20,
  },
  list_item_data: {
    color: 'black',
    width: '100%',
    marginRight: 10,
    padding: 3,
    fontSize: isMobileScreen ? 20 : 25,
    height: 35,
  },
  list_item_edit_picker: {
    padding: 3,
    fontSize: isMobileScreen ? 20 : 25,
    width: '100%',
    height: 35,
    borderWidth: 0,
    position: 'relative',
  },
  control: {
    marginTop: 20,
    flexDirection: 'row',
    alignSelf: 'center',
    marginBottom: 20,
  },
  control_btn_edit: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#cd2829',
    borderRadius: 10,
    padding: 10,
    paddingLeft: 20,
    paddingRight: 20,
  },
  control_btn_edit_text: {
    color: '#cd2829',
    fontSize: 14,
  },
  control_btn_save: {
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#cd2829',
    borderRadius: 10,
    padding: 10,
    paddingLeft: 20,
    paddingRight: 20,
  },
  control_btn_save_text: {
    color: '#cd2829',
    fontSize: 14,
  },
  control_btn_cancel: {
    marginLeft: 20,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 10,
    padding: 10,
    paddingLeft: 20,
    paddingRight: 20,
  },
  control_btn_cancel_text: {
    color: 'gray',
    fontSize: 14,
  },
  name: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#555555',
    textAlign: 'center',
  },
  listContainerBack: {
    backgroundColor: '#ffffff',
  },
  listContainer: {
    padding: 10,
  },
  listbirdbox: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
    marginBottom: 10,
  },
  birdlistHandle: {
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '2%',
    height: 70,
    width: isMobileScreen ? '6%' : '3%',
  },
  birdlistIcon: {
    resizeMode: 'contain',
    width: '100%',
    height: 70,
    userSelect: 'none',
    WebkitUserSelect: 'none',
    WebkitTouchCallout: 'none',
  },
  listItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f9f9f9',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
    width: isMobileScreen ? '92%' : '95%',
  },
  listbirdblock: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  listItemEditing: {
    backgroundColor: '#f5d4d4',
  },
  image: {
    width: 60,
    height: 60,
    borderRadius: 30,
    marginRight: 10,
  },
  text: {
    fontSize: isMobileScreen ? 18 : 20,
    color: '#555555',
  },
  Container20: {
    marginHorizontal: 20,
  },
  Container: {
    width: '100%',
    maxWidth: 800,
    marginHorizontal: 'auto',
    backgroundColor: '#fff',
    borderRadius: 15,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 10,
    elevation: 5,
    marginTop: 35,
    marginBottom: 35,
  },
  mainContainer: {
    paddingHorizontal: isMobileScreen ? 20 : 50,
    paddingBottom: isMobileScreen ? 0 : 80,
  },
  mainContainerTitle: {
    marginHorizontal: 'auto',
    marginBottom: isMobileScreen ? 10 : 50,
    color: '#555555',
    fontSize: 24,
  },
  name_edit: {
    textAlign: 'center',
    fontSize: isMobileScreen ? 21 : 30,
    maxWidth: 270,
    padding: 5,
    marginTop: isMobileScreen ? 0 : 10,
    marginHorizontal: 'auto',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 15,
  },
  list_item_row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  list_item_age: {},
  photo_space_back: {
    flex: 1,
    resizeMode: 'cover',
  },
  addBirdButton: {
    maxWidth: 200,
    marginHorizontal: 'auto',
    marginTop: isMobileScreen ? 10 : 30,
    marginBottom: isMobileScreen ? 20 : 40,
    flexDirection: 'row',
    textAlign: 'center',
    alignSelf: 'center',
    alignItems: 'center',
  },
  addBirdButtonText: {
    flexDirection: 'row',
    textAlign: 'center',
    alignSelf: 'center',
    alignItems: 'center',
  },
  plusIcon: {
    width: 30,
    height: 30,
    resizeMode: 'contain',
    marginRight: 10,
  },
  addText: {
    fontSize: isMobileScreen ? 18 : 24,
    color: '#555555',
  },
  inputActive: {
    color: '#555555',
  },
  inputPlaceholder: {
    color: '#bfbfbf',
  },
  editButton: {
    flexDirection: 'row',
    textAlign: 'center',
    alignSelf: 'center',
    alignItems: 'center',
  },
  editButtonText: {
    color: '#555555',
    fontSize: 18,
  },
  brideditIcon: {
    width: 25,
    height: 25,
    resizeMode: 'contain',
    marginRight: 10,
  },
  loadingView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  loadingText: {
    textAlign: 'center',
    color: '#555555',
    marginBottom: 10,
  },
};

export default BirdScreen;
